import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {Injectable} from '@angular/core';
import {Principal} from '../auth/principal.service';

@Injectable()
export class AgGridStateManagerService {

  account: any;

  constructor(
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private principal: Principal
  ) {
    this.getAccount();
  }

  saveOrder(gridName: string, gridState: any) {
    this.$localStorage.store(gridName + '_order_' + this.account.id + '_' + this.account.loggedAs.id, gridState);
    this.$sessionStorage.store(gridName + '_order_' + this.account.id + '_' + this.account.loggedAs.id, gridState);
  }

  getOrder(gridName: string) {
    return  this.$sessionStorage.retrieve(gridName + '_order_' + this.account.id + '_' + this.account.loggedAs.id) ||
      this.$localStorage.retrieve(gridName + '_order_' + this.account.id + '_' + this.account.loggedAs.id);
  }


  saveState(gridName: string, gridState: any) {
    this.$localStorage.store(gridName + '_state_' + this.account.id + '_' + this.account.loggedAs.id, gridState);
    this.$sessionStorage.store(gridName + '_state_' + this.account.id + '_' + this.account.loggedAs.id, gridState);
  }

  getState(gridName: string) {
    return  this.$sessionStorage.retrieve(gridName + '_state_' + this.account.id + '_' + this.account.loggedAs.id) ||
            this.$localStorage.retrieve(gridName + '_state_' + this.account.id + '_' + this.account.loggedAs.id);
  }

  saveGroup(gridName: string, gridState: any) {
    this.$localStorage.store(gridName + '_group_' + this.account.id + '_' + this.account.loggedAs.id, gridState);
    this.$sessionStorage.store(gridName + '_group_' + this.account.id + '_' + this.account.loggedAs.id, gridState);
  }

  getGroup(gridName: string) {
    return  this.$sessionStorage.retrieve(gridName + '_group_' + this.account.id + '_' + this.account.loggedAs.id) ||
            this.$localStorage.retrieve(gridName + '_group_' + this.account.id + '_' + this.account.loggedAs.id) || [];
  }

  resetState(gridName: string) {
    this.$localStorage.clear(gridName + '_' + this.account.id + '_' + this.account.loggedAs.id);
    this.$sessionStorage.clear(gridName + '_' + this.account.id + '_' + this.account.loggedAs.id);
  }

  private getAccount() {
    this.principal.identity().then((account) => {
      this.account = account;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/agGridStateManager.service.ts